import ApiService from './ApiService'

import AuthService from './AuthService'

import {
    usuarioInfo,
} from './UsuarioService'

import HARDCODE from '../business-const/HardCode/HardCode'

import {
    ano,
    mes,
    dia,
} from '../business-components/Date/Date'



class VwAporteService extends ApiService {

    constructor() {
        super(HARDCODE.apiVwAporte)
    }
    
    putAporteList(variaveisGlobais, aporteList) {

        return this.put(variaveisGlobais, HARDCODE.apiVwAportePutAporteList, aporteList, false)
    }

    async buscarAporteList(variaveisGlobais, idClienteNull, dataPrevistaAporteNull) {

        /*
        let params = `idUsuario=${AuthService.obterUsuarioLogado(variaveisGlobais)}`

        params = `${params}&jsonUsuarioSelecionado=${AuthService.usuarioSelecionadoList(variaveisGlobais)}`

        if (idClienteNull) {
            
            params = `${params}&idCliente=${idClienteNull}`
        }

        if (dataPrevistaAporteNull) {

            params = `${params}&dataPrevistaAporteAno=${ano(dataPrevistaAporteNull)}`
            params = `${params}&dataPrevistaAporteMes=${mes(dataPrevistaAporteNull)}`
            params = `${params}&dataPrevistaAporteDia=${dia(dataPrevistaAporteNull)}`
        }

        const paramsAux = {
            params: {
                jsonLogAcessoApi: await usuarioInfo()
            }
        }

        return this.getParams(variaveisGlobais, `${HARDCODE.apiVwAporteBuscarAporteList}/?${params}`, paramsAux, false)
        */

        const body = {
            getDTO: {
                idUsuario: AuthService.obterUsuarioLogado(variaveisGlobais),
                jsonUsuarioSelecionado: AuthService.usuarioSelecionadoListString(variaveisGlobais),
                idCliente: idClienteNull ? idClienteNull : null,
                dataPrevistaAporteAno: dataPrevistaAporteNull ? ano(dataPrevistaAporteNull) : null,
                dataPrevistaAporteMes: dataPrevistaAporteNull ? mes(dataPrevistaAporteNull) : null,
                dataPrevistaAporteDia: dataPrevistaAporteNull ? dia(dataPrevistaAporteNull) : null,
            },
            logAcessoApiDTO: await usuarioInfo(),
        }

        return this.put(variaveisGlobais, HARDCODE.apiVwAporteBuscarAporteList, body, false)
    }

    async calculaParamsSumAporte(variaveisGlobais, tipoSum, dataInicial, dataFinal) {

        /*
        let params = `idUsuario=${AuthService.obterUsuarioLogado(variaveisGlobais)}`

        params = `${params}&jsonUsuarioSelecionado=${AuthService.usuarioSelecionadoList(variaveisGlobais)}`

        params = `${params}&tipoSum=${tipoSum}`

        params = `${params}&dataInicialAno=${ano(dataInicial)}`
        params = `${params}&dataInicialMes=${mes(dataInicial)}`
        params = `${params}&dataInicialDia=${dia(dataInicial)}`

        params = `${params}&dataFinalAno=${ano(dataFinal)}`
        params = `${params}&dataFinalMes=${mes(dataFinal)}`
        params = `${params}&dataFinalDia=${dia(dataFinal)}`

        const paramsAux = {
            params: {
                jsonLogAcessoApi: await usuarioInfo()
            }
        }

        return { params, paramsAux }
        */

        const body = {
            getDTO: {
                idUsuario: AuthService.obterUsuarioLogado(variaveisGlobais),
                jsonUsuarioSelecionado: AuthService.usuarioSelecionadoListString(variaveisGlobais),
                tipoSum: tipoSum,
                dataInicialAno: ano(dataInicial),
                dataInicialMes: mes(dataInicial),
                dataInicialDia: dia(dataInicial),
                dataFinalAno: ano(dataFinal),
                dataFinalMes: mes(dataFinal),
                dataFinalDia: dia(dataFinal),
            },
            logAcessoApiDTO: await usuarioInfo(),
        }

        return body
    }

    async sumAporte(variaveisGlobais, tipoSum, dataInicial, dataFinal) {

        /*
        const { params, paramsAux } = await this.calculaParamsSumAporte(variaveisGlobais, tipoSum, dataInicial, dataFinal)
        
        return this.getParams(variaveisGlobais, `${HARDCODE.apiVwAporteSum}/?${params}`, paramsAux, false)
        */

        const body = await this.calculaParamsSumAporte(variaveisGlobais, tipoSum, dataInicial, dataFinal)

        return this.put(variaveisGlobais, HARDCODE.apiVwAporteSum, body, false)
    }
    
    async sumDataAporte(variaveisGlobais, tipoSum, dataInicial, dataFinal) {

        /*
        const { params, paramsAux } = await this.calculaParamsSumAporte(variaveisGlobais, tipoSum, dataInicial, dataFinal)

        return this.getParams(variaveisGlobais, `${HARDCODE.apiVwAporteSumData}/?${params}`, paramsAux, false)
        */

        const body = await this.calculaParamsSumAporte(variaveisGlobais, tipoSum, dataInicial, dataFinal)

        return this.put(variaveisGlobais, HARDCODE.apiVwAporteSumData, body, false)
    }
    
    enviarLembreteAporte(variaveisGlobais) {

        let params = `idUsuario=${AuthService.obterUsuarioLogado(variaveisGlobais)}`

        return this.get(variaveisGlobais, `${HARDCODE.apiVwAporteEnviarLembreteAporte}/?${params}`, false)
    }
}

export default VwAporteService